module.exports = __webpack_public_path__ + "static/media/bac-star.e5fc88d0.svg";